/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_In_PersonInputs */

const cs_enum_in_person = /** @type {(inputs: Enum_In_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osobně`)
};

const en_enum_in_person = /** @type {(inputs: Enum_In_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In person`)
};

/**
* | output |
* | --- |
* | "In person" |
*
* @param {Enum_In_PersonInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_in_person = /** @type {((inputs?: Enum_In_PersonInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_In_PersonInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_in_person(inputs)
	return cs_enum_in_person(inputs)
});